/* =====================================================================
   PB CART v2 — skrevet om fra bunden. ÉN regel: kunden bestemmer, skærmen følger kunden.

   MODEL
   · server = Shopifys sidste kurv (linjer, priser, rabatter).
   · want   = hvad kunden VIL have: { linje-id: antal }. Hvert klik ændrer KUN want og tegner
              kurven med det samme (antal, priser, rabatter, førpris, fri fragt, total).
   · Synk er DEKLARATIV: vi sender "sådan skal kurven se ud" (/cart/update.js), aldrig
     "+1 / -1". Derfor kan hurtige klik aldrig lægge sig oveni hinanden, komme i forkert
     rækkefølge eller ramme en forældet linje ("ugyldigt id"). Højst ét kald ad gangen;
     klikker kunden mens det er undervejs, sendes den NYESTE tilstand bagefter.
   · Lager og købsgrænser kendes i browseren (fra varens data), så knappen stopper ved
     grænsen FØR Shopify siger nej. Hvis Shopify alligevel giver færre, retter kurven sig
     til Shopifys tal med ÉN besked (aldrig en stak af ens beskeder).
   · Kurven er færdig når siden vises (serveren tegner den + data i siden).
   API: PB.cart.add(item, qty) · .set(lineKey, qty) · .open() · .close() · .get() · .idle() · .refresh() · PB.qd (mængderabat)
   ===================================================================== */
(function () {
  'use strict';
  var d = document, w = window, PB = w.PB;
  if (!PB || PB.cart) return;
  var R = PB.cfg.routes || {};
  var URL_UPD = (R.update || '/cart/update') + '.js', URL_GET = (R.cart || '/cart') + '.js';

  var server = null;         /* Shopifys sidste kurv */
  var want = {};             /* linje-id → ønsket antal (kun det der endnu ikke er bekræftet) */
  var meta = {};             /* variant-id → { title, vt, img, url, price, compare, stock, max, pool, pmax } */
  var sending = false, again = false, waiters = [], recT = null;
  var root, panel, body, pageEl, lastFocus;

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function T(k, n, v) { var s = PB.t(k); return n ? s.replace('[' + n + ']', v) : s; }
  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function num(x) { return parseInt(x, 10) || 0; }

  /* ---------------- start: kurv + varedata ligger allerede i siden ---------------- */
  try { var b1 = $('script[data-pb-cart-json]'); if (b1) server = JSON.parse(b1.textContent); } catch (e) {}
  try {
    var b2 = $('script[data-pb-cart-meta]');
    if (b2) { var m0 = JSON.parse(b2.textContent) || {}; Object.keys(m0).forEach(function (v) { var x = m0[v]; meta[v] = { compare: num(x.c), stock: num(x.s), max: num(x.m), pool: x.p || '', pmax: num(x.pm), qk: x.qk || '', qn: x.qn || '', qt: qdParse(x.qt), mp: x.mp == null ? null : x.mp }; }); }
  } catch (e) {}
  if (!server) server = { items: [], cart_level_discount_applications: [], discount_codes: [] };
  /* upsell-forslag ligger også i siden (pb-upsell-data) → klar med det samme */
  var UP = { def: [], cols: {}, prod: {}, pcols: {} };
  try { var b3 = $('script[data-pb-upsell-json]'); if (b3) { var u0 = JSON.parse(b3.textContent) || {}; UP.def = u0.def || []; UP.cols = u0.cols || {}; UP.prod = u0.prod || {}; UP.pcols = u0.pcols || {}; } } catch (e) {}

  PB.cart = { get: view, add: add, set: setQty, open: open, close: close, refresh: refresh, idle: whenIdle };

  /* ---------------- linje-id: varianten (almindelige linjer) eller Shopifys nøgle (linjer med egenskaber) ---------------- */
  function hasProps(i) { return i.properties && Object.keys(i.properties).some(function (k) { return i.properties[k] !== '' && i.properties[k] != null; }); }
  function lid(i) { return hasProps(i) ? 'k:' + i.key : String(i.variant_id); }
  function serverQty(id) { return server.items.reduce(function (a, i) { return a + (lid(i) === id ? i.quantity : 0); }, 0); }
  function wantQty(id) { return id in want ? want[id] : serverQty(id); }

  /* ---------------- visning = server + kundens ønsker (+ rabatter regnet lokalt) ---------------- */
  function view() {
    var c = clone(server), seen = {};
    c.items = c.items.filter(function (i) {
      var id = lid(i); seen[id] = 1;
      if (!(id in want)) return true;
      var q = want[id];
      if (q <= 0) return false;
      if (q !== i.quantity) { i._q0 = i.quantity; i.quantity = q; i.final_line_price = i.final_price * q; i.original_line_price = i.original_price * q; }
      return true;
    });
    Object.keys(want).forEach(function (id) {
      if (seen[id] || want[id] <= 0 || id.indexOf('k:') === 0) return;
      var m = meta[id]; if (!m || !m.title) return;
      var q = want[id];
      c.items.unshift({ key: 'new-' + id, variant_id: +id, product_id: m.pid, product_title: m.title, variant_title: m.vt, image: m.img, url: m.url, quantity: q,
        final_price: m.price, original_price: m.price, final_line_price: m.price * q, original_line_price: m.price * q,
        properties: {}, line_level_discount_allocations: [], selling_plan_allocation: m.spn ? { selling_plan: { name: m.spn } } : null, _new: true });
    });
    mirror(c);
    return retotal(c);
  }
  function retotal(c) {
    var n = 0, sub = 0;
    c.items.forEach(function (i) { n += i.quantity; sub += i.final_line_price; });
    var cd = (c.cart_level_discount_applications || []).reduce(function (a, x) { return a + (x.total_allocated_amount || 0); }, 0);
    c.item_count = n; c.items_subtotal_price = sub; c.total_price = Math.max(0, sub - cd);
    return c;
  }

  /* ---------------- rabatter regnet hos kunden (spejler de rabatter Shopify bruger i kurven) ---------------- */
  var memo = {}; try { memo = JSON.parse(localStorage.getItem('pbDisc3') || '{}'); } catch (e) {}
  /* koder fra Theme settings → Kurv ("KODE:procent") → kendt fra første sekund */
  (PB.cfg.cartCodes || '').split(/\n+/).forEach(function (line) {
    var p = line.trim().split(':'); if (p.length < 2) return;
    var code = p[0].trim(), pct = parseFloat(String(p[1]).replace(',', '.'));
    if (code && pct > 0) memo[code] = { lvl: 'cart', da: { title: code, key: code, type: 'discount_code', value: String(pct), value_type: 'percentage', allocation_method: 'across', target_selection: 'all', target_type: 'line_item' } };
  });
  function learn(s) {
    var ch = false;
    (s.cart_level_discount_applications || []).forEach(function (da) { if (da.value_type === 'percentage') { memo[da.title || da.key] = { lvl: 'cart', da: da }; ch = true; } });
    (s.items || []).forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { var da = a.discount_application; if (da && da.value_type === 'percentage' && da.target_selection === 'all') { memo[da.title || da.key] = { lvl: 'line', da: da }; ch = true; } }); });
    if (ch) try { localStorage.setItem('pbDisc3', JSON.stringify(memo)); } catch (e) {}
  }
  function mirror(c) {
    var rules = {}, codes = (server.discount_codes || []).filter(function (x) { return x.applicable !== false; }).map(function (x) { return x.code; }); /* kun koder Shopify faktisk giver */
    Object.keys(memo).forEach(function (k) {
      if (codes.indexOf(k) < 0) return;
      var m = memo[k];
      if (m.lvl === 'cart' && !(c.cart_level_discount_applications || []).some(function (x) { return (x.title || x.key) === k; })) c.cart_level_discount_applications = (c.cart_level_discount_applications || []).concat([clone(m.da)]);
      if (m.lvl === 'line') rules[k] = { da: m.da, v: {} };
    });
    server.items.forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        var da = a.discount_application; if (!da) return;
        var k = da.title || da.key; if (!rules[k]) rules[k] = { da: da, v: {} };
        rules[k].v[i.variant_id] = 1;
      });
    });
    c.items.forEach(function (i) {
      if (i._new) {
        Object.keys(rules).forEach(function (k) {
          var r = rules[k], da = r.da;
          if (da.value_type !== 'percentage' || (da.target_type && da.target_type !== 'line_item')) return;
          if (da.target_selection !== 'all' && !r.v[i.variant_id]) return;
          var amt = Math.round(i.original_line_price * parseFloat(da.value) / 100);
          if (amt > 0) { i.line_level_discount_allocations.push({ amount: amt, discount_application: da }); i.final_line_price -= amt; }
        });
      } else if (i._q0) {
        (i.line_level_discount_allocations || []).forEach(function (a) { a.amount = Math.round(a.amount * i.quantity / i._q0); });
      }
    });
    discMirror(c);
var sub = c.items.reduce(function (a, i) { return a + i.final_line_price; }, 0);
    (c.cart_level_discount_applications || []).forEach(function (da) { if (da.value_type === 'percentage') da.total_allocated_amount = Math.round(sub * parseFloat(da.value) / 100); });
  }

  /* ---------------- mængderabat — SAMME regel som rabat-funktionen i pb-tools (qty-discount) ----------------
Trin + gruppe kommer fra varens data (pb-qd-vals). Shopify lægger rabatten på i kurv og checkout; her vises den
med det samme når kunden ændrer antal — også første gang et trin nås. Trinene står kun på varer i AKTIVE
mængderabatter (pb-server fjerner dem, når en rabat stopper), og Shopifys svar retter altid tallene bagefter.
Firmakunder (B2B) får ikke mængderabat og ser den derfor ikke. Under gruppens sidste linje: "Køb 1 mere og spar 5 %". */
function qdParse(s) {
var out = [];
String(s || '').split(/[,;\n]+/).forEach(function (part) {
var m = part.trim().match(/^(\d{1,4})\s*:\s*(\d{1,2}(?:\.\d{1,2})?)\s*%?$/); if (!m) return;
var q = parseInt(m[1], 10), p = Math.min(50, parseFloat(m[2]));
if (q >= 2 && p > 0) out.push([q, p]);
});
return out.sort(function (a, b) { return a[0] - b[0]; });
}
function qdPct(t, n) { var p = 0; t.forEach(function (x) { if (n >= x[0]) p = x[1]; }); return p; }
function qdGroups(c) {
if (c._qd) return c._qd;
var G = {};
(c.items || []).forEach(function (i) {
var m = meta[i.variant_id] || {}; if (!m.qk || !m.qt || !m.qt.length) return;
var x = G[m.qk] || (G[m.qk] = { qty: 0, items: [], tiers: [] });
x.qty += i.quantity; x.items.push(i); x.tiers.push(m.qt);
});
try { Object.defineProperty(c, '_qd', { value: G, configurable: true }); } catch (e) {}
return G;
}
function qdGroupPct(x) { return Math.min.apply(null, x.tiers.map(function (t) { return qdPct(t, x.qty); })); } /* forskellige trin i samme gruppe → det laveste gælder */
function qdNext(x) {
var cur = qdGroupPct(x), qs = [];
x.tiers.forEach(function (t) { t.forEach(function (y) { if (y[0] > x.qty && qs.indexOf(y[0]) < 0) qs.push(y[0]); }); });
qs.sort(function (a, b) { return a - b; });
for (var j = 0; j < qs.length; j++) {
var q = qs[j], p = Math.min.apply(null, x.tiers.map(function (t) { return qdPct(t, q); }));
if (p > cur) return [q, p];
}
return null;
}
function qdFmt(p) { var s = String(p); return PB.cfg.lang === 'en' ? s : s.replace('.', ','); }
/* ---------------- rabatterne med det samme — SAMME regler som rabat-funktionerne i pb-tools ----------------
   qty-discount (mængderabat) + member-discount (medlemspris): Shopify giver kun ÉN produktrabat pr. vare (den største).
   For medlemmer er medlemsprisen grundprisen, og mængderabatten regnes af den (når Medlemskab siger "lægges sammen").
   Rabatten regnes pr. stk. og rundes ned til hele øre × antal. Andre rabatter på samme vare (rabatkoder, andre apps)
   konkurrerer: den største vinder, præcis som hos Shopify. Kun når kurven er ændret hos kunden — ellers gælder Shopifys tal.
   PB.cfg.member: { enabled (checkout giver medlemspris), cust (kunden er medlem), std, comb, pid (medlemsvaren), b2b } */
var MB = PB.cfg.member || {};
  /* MYSTERY-GAVER (pb-server bday.js + mwheel.js): fødselsdagsgaven (PB.cfg.member.bc) og gevinster fra Ugens spin
     (PB.cfg.member.wg = [{ s, v, until, used }]). Gyldige gaver i kurven → gratis fragt og fast antal — samme regel som kassen
     (member-guard/member-discount · giftCheck): hvert stk. skal have sit eget krav (valgt brand, ikke brugt, inden fristen);
     fødselsdagens krav bruges først. */
  function isGift(i) { return !!(MB.bg && i && Number(i.product_id) === Number(MB.bg)); }
  function giftClaims() {
    var today = new Date().toISOString().slice(0, 10), out = [];
    function live(x) { return !!x && !!x.v && x.used !== true && (!x.until || today <= x.until); }
    if (MB.bc && MB.bc.c === 'gift' && live(MB.bc)) out.push(String(MB.bc.v));
    (MB.wg || []).forEach(function (x) { if (live(x)) out.push(String(x.v)); });
    return out;
  }
  function giftFree(c) {
    var g = ((c && c.items) || []).filter(isGift), cl = giftClaims(); if (!g.length) return false;
    for (var i = 0; i < g.length; i++) for (var n = 0; n < g[i].quantity; n++) {
      var k = cl.indexOf(String(g[i].variant_id)); if (k < 0) return false; cl.splice(k, 1);
    }
    return true;
  }
var OURS = ['qd_msg', 'mb_msg', 'qd_mb_msg'].map(function (k) { return String(T(k) || '').split('[')[0].trim(); }).filter(Boolean);
function discOurs(a) { var t = (a && a.discount_application && a.discount_application.title) || ''; return OURS.some(function (l) { return t.indexOf(l) === 0; }); }
/* rabat pr. stk. i øre: medlemspris (rundet op til x,95 — PB.mUnit) og/eller mængderabat; er "lægges sammen" slået til,
   regnes mængderabatten af medlemsprisen og rundes op til x,95 (PB.mqUnit). Samme regel som kassen (pb-tools · member-core.js). */
function qdCut(c, p) { return Math.floor(c * Math.round(p * 100) / 10000); }
function unitOff(P, vol, mem) {
var mu = mem > 0 ? PB.mUnit(P, mem) : P, best = Math.max(P - mu, vol > 0 ? qdCut(P, vol) : 0);
if (vol > 0 && mu < P && MB.comb !== false) { var r = PB.mqUnit(mu, vol); if (r < mu) best = Math.max(best, P - r); }
return best;
}
function mbActive(c) {
if (!MB.enabled || MB.b2b) return false;
if (MB.cust) return true;
return !!MB.pid && (c.items || []).some(function (i) { return String(i.product_id) === String(MB.pid); }); /* medlemspris allerede på tilmeldingsordren */
}
function mbPct(i, on) {
if (!on || i.gift_card || (MB.pid && String(i.product_id) === String(MB.pid))) return 0;
var m = meta[i.variant_id] || {}, p = m.mp != null && m.mp !== '' ? Number(m.mp) : Number(MB.std || 0);
p = p > 0 ? Math.min(90, Math.round(p * 100) / 100) : 0;
return p > 0 && PB.mUnit(i.original_price, p) < i.original_price ? p : 0; /* æder afrundingen til x,95 hele rabatten, er der ingen medlemspris */
}
/* OVERGANG mens Rockit kører: for kunder, hvor vores mængderabat er i testtilstand (qd_off), giver Rockit mængderabatten
   med samme trin. Kurven regner den efter Rockits regel (procent af hele linjen, afrundet til hele øre) og husker Rockits
   navn pr. gruppe, så intet hopper. Rabatkoder røres ikke. Fjernes, når Rockit slås fra (qd_off er så altid false). */
var qdLeg = {}; try { qdLeg = JSON.parse(localStorage.getItem('pbQdLeg') || '{}') || {}; } catch (e) { qdLeg = {}; }
function qdLegacyA(a) { var da = a && a.discount_application, t = da && da.type; return !!da && t !== 'discount_code' && t !== 'manual' && t !== 'script' && !discOurs(a); } /* funktions-rabatter har type "" eller "automatic" */
function qdLegLearn(c) {
var ch = false;
(c.items || []).forEach(function (i) { var k = (meta[i.variant_id] || {}).qk; if (!k) return; (i.line_level_discount_allocations || []).forEach(function (a) { if (qdLegacyA(a) && qdLeg[k] !== a.discount_application.title) { qdLeg[k] = a.discount_application.title; ch = true; } }); });
if (ch) try { localStorage.setItem('pbQdLeg', JSON.stringify(qdLeg)); } catch (e) {}
}
function discMirror(c) {
var items = c.items || [];
var dirty = items.some(function (i) { return i._new || i._q0; }) || !!(server && server.items && items.length < server.items.length);
if (PB.cfg.qd_off) qdLegLearn(c);
if (!dirty) return; /* ingen ændring hos kunden → Shopifys tal gælder */
var G = qdGroups(c), on = mbActive(c), b2b = !!(PB.cfg.customer || {}).b2b;
items.forEach(function (i) {
var m = meta[i.variant_id] || {}, x = m.qk && !b2b ? G[m.qk] : null;
var vol = x && !PB.cfg.qd_off ? qdGroupPct(x) : 0, mem = mbPct(i, on); /* qd_off: vores mængderabatter er i testtilstand og gælder ikke denne kunde */
var P = i.original_price, mOff = mem > 0 ? P - PB.mUnit(P, mem) : 0, vOff = vol > 0 ? qdCut(P, vol) : 0, uo = unitOff(P, vol, mem);
var amt = uo * i.quantity, kind = uo <= 0 ? '' : (vol > 0 && mem > 0 && MB.comb !== false && uo > Math.max(mOff, vOff) ? 'both' : (vOff >= mOff ? 'qd' : 'mb'));
var other = (i.line_level_discount_allocations || []).filter(function (a) { return !discOurs(a); });
if (PB.cfg.qd_off && x) { /* overgang: Rockits mængderabat (se ovenfor) */
var lv = qdGroupPct(x), lt = qdLeg[m.qk] || T('qd_msg').replace('[p]', qdFmt(lv));
other = other.filter(function (a) { return !qdLegacyA(a); });
if (lv > 0) other.push({ amount: Math.round(i.original_line_price * lv / 100), discount_application: { type: 'automatic', title: lt, value: String(lv), value_type: 'percentage', allocation_method: 'across', target_selection: 'entitled', target_type: 'line_item' } });
}
var best = other.reduce(function (s, a) { return Math.max(s, a.amount || 0); }, 0);
var keep = other;
if (amt > 0 && amt >= best) {
var title = kind === 'both' ? T('qd_mb_msg').replace('[p]', qdFmt(vol)).replace('[m]', qdFmt(mem)) : kind === 'qd' ? T('qd_msg').replace('[p]', qdFmt(vol)) : T('mb_msg').replace('[p]', qdFmt(mem));
keep = [{ amount: amt, discount_application: { type: 'automatic', title: title, value: String(P > 0 ? Math.round(uo * 10000 / P) / 100 : 0), value_type: 'percentage', allocation_method: 'across', target_selection: 'entitled', target_type: 'line_item' } }];
}
i.line_level_discount_allocations = keep;
i.final_line_price = i.original_line_price - keep.reduce(function (s, a) { return s + (a.amount || 0); }, 0);
});
}
/* ÉN fast rabatlinje pr. vare, der kan få mængderabat/medlemspris — højden ændrer sig aldrig, når antallet ændres.
   Rabat givet → rabatten (+ evt. næste trin). Ellers: tip på gruppens sidste vare, "Tæller med i …" på de andre.
   Den længste udgave, der kan stå på én linje, vælges (fitDeals) — beløbet står allerede i priskolonnen. */
function dealHTML(c, i) {
var m = meta[i.variant_id] || {}, b2b = !!(PB.cfg.customer || {}).b2b;
var x = m.qk && !b2b && !PB.cfg.qd_off ? qdGroups(c)[m.qk] : null, mem = mbPct(i, mbActive(c));
var al = (i.line_level_discount_allocations || []).filter(function (a) { return a.amount > 0 && discOurs(a); })[0];
if (!x && !al) return '';
var nx = x && x.items[x.items.length - 1] === i ? qdNext(x) : null, alts = [], tip = !al;
var nudge = nx ? [T(m.qn ? 'qd_next_g' : 'qd_next'), T('qd_next'), T('qd_tiny')].map(function (s) { return s.replace('[g]', m.qn || '').replace('[n]', nx[0] - x.qty).replace('[p]', qdFmt(nx[1])); }) : null;
if (al) {
var t = al.discount_application.title || '', vol = x ? qdGroupPct(x) : 0, tot = al.discount_application.value_type === 'percentage' ? parseFloat(al.discount_application.value) || 0 : (i.original_line_price > 0 ? Math.round(al.amount * 10000 / i.original_line_price) / 100 : 0); /* kassens medlemspris er et fast beløb pr. stk. */
if (nudge) alts.push(t + ' · ' + nudge[1]);
alts.push(t);
if (vol > 0 && mem > 0 && MB.comb !== false) alts.push(T('qd_mb_short').replace('[p]', qdFmt(vol)).replace('[m]', qdFmt(mem)));
if (tot > 0) alts.push(T('disc_pct').replace('[p]', qdFmt(tot)));
} else alts = nudge || (m.qn ? [T('qd_hint_g').replace('[g]', m.qn), T('qd_hint')] : [T('qd_hint')]);
return '<span class="pb-line__deal' + (tip ? ' is-tip' : '') + '" data-fit="' + PB.esc(JSON.stringify(alts)) + '">' + PB.esc(alts[0]) + '</span>';
}
function fitDeals(box) {
if (!box) return;
$$('[data-fit]', box).forEach(function (el) {
var alts; try { alts = JSON.parse(el.getAttribute('data-fit')); } catch (e) { return; }
if (!alts || !alts.length) return;
if (!el.clientWidth) { if (el.textContent !== alts[0]) el.textContent = alts[0]; return; } /* skjult kurv: tilpasses, når den åbnes */
for (var k = 0; k < alts.length; k++) { if (el.textContent !== alts[k]) el.textContent = alts[k]; if (el.scrollWidth <= el.clientWidth + 1) return; }
});
}
var fitObs = null;
function fitWatch() {
if (fitObs || !window.ResizeObserver) return;
fitObs = new ResizeObserver(function () { fitDeals(root); fitDeals(pageEl); });
if (panel || body) fitObs.observe(panel || body);
if (pageEl) fitObs.observe(pageEl);
}
PB.qd = { parse: qdParse, pct: qdPct, groupQty: function (c, k) { var x = c ? qdGroups(c)[k] : null; return x ? x.qty : 0; } };

/* ---------------- grænser: lager (når det er lavt), maks. pr. ordre, pulje ---------------- */
  function capFor(c, vid, excludeKey) {
    var m = meta[vid] || {}, cap = Infinity, why = '';
    if (m.stock > 0 && m.stock < cap) { cap = m.stock; why = T('cart_stock', 'n', m.stock); }
    if (m.max > 0 && m.max < cap) { cap = m.max; why = T('cart_limit', 'n', m.max); }
    if (m.pool && m.pmax > 0) {
      var used = c.items.reduce(function (a, i) { var mi = meta[i.variant_id] || {}; return a + (mi.pool === m.pool && i.key !== excludeKey && i.variant_id !== vid ? i.quantity : 0); }, 0);
      var left = Math.max(0, m.pmax - used);
      if (left < cap) { cap = left; why = T('cart_limit', 'n', m.pmax); }
    }
    return { n: cap, why: why };
  }

  /* Købsgrænser gælder også det, der ALLEREDE ligger i kurven (fx lagt i via et link, en anden fane eller kurvens API):
   en linje over grænsen rettes ned med det samme, og kunden får at vide hvorfor. Samme regel som checkout (limit-one):
   maks. pr. kunde gælder varen samlet (alle varianter) · i en pulje beholdes de første linjer. Lager klarer Shopify selv. */
var capTried = {};
function enforceCaps(c) {
  var byProd = {}, byPool = {}, fix = [], why = '';
  c.items.forEach(function (i) {
    if (i._new) return;                                    /* lige lagt i via temaet — allerede begrænset af capFor */
    var m = meta[i.variant_id] || {}, lim = m.max > 0, pl = !!(m.pool && m.pmax > 0);
    if (!lim && !pl) return;                               /* almindelige varer: røres og tælles aldrig */
    var allow = i.quantity, pk = i.product_id || ('v' + i.variant_id);
    if (lim) { var leftP = Math.max(0, m.max - (byProd[pk] || 0)); if (leftP < allow) { allow = leftP; why = T('cart_limit', 'n', m.max); } }
    if (pl) { var leftL = Math.max(0, m.pmax - (byPool[m.pool] || 0)); if (leftL < allow) { allow = leftL; why = T('cart_limit', 'n', m.pmax); } }
    if (lim) byProd[pk] = (byProd[pk] || 0) + allow;
    if (pl) byPool[m.pool] = (byPool[m.pool] || 0) + allow;
    if (allow < i.quantity) { var id = lid(i); capTried[id] = (capTried[id] || 0) + 1; if (capTried[id] <= 3) fix.push([id, allow]); }   /* aldrig i ring */
  });
  if (!fix.length) return false;
  fix.forEach(function (f) { want[f[0]] = f[1]; });
  say(why); sync();
  return true;
}

/* ---------------- kundens handlinger: ændrer KUN want + tegner med det samme ---------------- */
  var toastSeen = {};
  /* RIP N SHIP (type/vendor "Rip n Ship", mærket ripnship): åbnes live i gameshowet og sendes senere — kan ikke ligge i kurv med
     almindelige varer, der skal sendes nu (samme regel som checkout: pb-tools · limit-one, teksten checkout.lim_rns), og foreslås
     aldrig som upsell. En kurv med rip n ship får ingen forslag, og fragten står som gratis (den trækkes automatisk fra). */
  var RS = 'Rip n Ship';
  function ptOf(i) { return (i && (i.product_type || i.pt || (meta[String(i.variant_id)] || {}).pt)) || ''; }
  function isRS(i) { return !!i && (i.rs === 1 || i.rs === true || ptOf(i) === RS || i.vendor === RS || (meta[String(i.variant_id)] || {}).rs === 1); }
  function plainItem(i) { return !!i && !isRS(i) && !i.gift_card && i.requires_shipping !== false && ptOf(i) !== 'Medlemskab'; }   /* skal sendes nu */
  function hasRS(c) { return c.items.some(isRS); }
  function rsFree(c) { return hasRS(c) && !c.items.some(plainItem); }
  function say(msg) { if (!msg) return; var t = Date.now(); if (toastSeen[msg] && t - toastSeen[msg] < 4000) return; toastSeen[msg] = t; PB.toast(msg, true); }
  function add(item, qty) {
    var vid = String(item.id);
    var c0 = view();   /* rip n ship og almindelige varer kan ikke ligge i samme kurv */
    if (isRS(item) ? c0.items.some(plainItem) : (plainItem(item) && hasRS(c0))) { say(T('rns_mix')); return false; }
    setTimeout(function () { loadPool(); loadRel(view()); }, 0);   /* forbered fri fragt-forslaget i baggrunden */
    if (item.up) UP.prod[item.product_id] = item.up;
    if (item.cols) UP.pcols[item.product_id] = item.cols;
    /* felter, kilden ikke sender med, beholder det kurven allerede ved om varen (fx fra siden) — aldrig tomme værdier oveni */
    var old = meta[vid] || {}, has = function (k) { return item[k] !== undefined && item[k] !== null; };
    meta[vid] = Object.assign(old, { pid: item.product_id, g: item.g || '', pt: item.pt || '', title: item.title, vt: item.variant_title, img: item.image, url: item.url, price: num(item.price),
          compare: num(item.compare), stock: num(item.stock), max: has('max') ? num(item.max) : num(old.max), pool: has('pool') ? item.pool : (old.pool || ''), pmax: has('pmax') ? num(item.pmax) : num(old.pmax),
          qk: has('qk') ? item.qk : (old.qk || ''), qn: has('qn') ? item.qn : (old.qn || ''), qt: has('qt') ? qdParse(item.qt) : (old.qt || []), mp: has('mp') ? item.mp : (old.mp == null ? null : old.mp), sp: has('sp') ? item.sp : (old.sp || null), spn: has('spn') ? item.spn : (old.spn || '') });
    if (item.rs) meta[vid].rs = 1;
    var c = view(), cur = wantQty(vid), next = cur + Math.max(1, num(qty) || 1), cap = capFor(c, vid, null);
    if (next > cap.n) { say(cap.why); next = cap.n; }
    open();
    if (next === cur) return;
    want[vid] = next;
    paint(); PB.emit('cart:add', { item: item, qty: next - cur }); sync();
  }
  function setQty(key, qty) {
    var c = view(), line = c.items.filter(function (i) { return i.key === key; })[0]; if (!line) return;
    var id = lid(line), next = Math.max(0, num(qty)), cap = capFor(c, line.variant_id, key);
    if (next > cap.n) { say(cap.why); next = cap.n; }
    if (next === line.quantity) { paint(); return; }
    want[id] = next;
    paint(); sync();
  }

  /* ---------------- synk: "sådan skal kurven se ud" — ét kald ad gangen, nyeste tilstand vinder ---------------- */
  function req(url, data) {
    return fetch(url, data ? { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) }
      : { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { j.status = r.status; throw j; } return j; }); });
  }
  function pending() { return Object.keys(want).filter(function (id) { return serverQty(id) !== want[id]; }); }
  function sync() {
    if (sending) { again = true; return; }
    var ids = pending();
    if (!ids.length) { want = {}; flush(); reconcileLater(); return; }
    /* medlemskab (abonnement): /cart/update.js kan ikke sætte abonnementet → nye abonnementslinjer sendes via /cart/add.js.
   Linjen står allerede i kurven; afviser Shopify (fx "Medlemskab er ikke åbent endnu"), vises beskeden, og kurven går tilbage. */
var spIds = ids.filter(function (id) { var m = meta[id]; return m && m.sp && serverQty(id) === 0 && want[id] > 0; });
if (spIds.length) {
var sentSp = {}; spIds.forEach(function (id) { sentSp[id] = want[id]; });
sending = true; again = false;
req(URL_UPD.replace(/update\.js/, 'add.js'), { items: spIds.map(function (id) { return { id: +id, quantity: want[id], selling_plan: meta[id].sp }; }) })
.then(function () { return req(URL_GET); })
.then(function (c) { server = c; learn(c); sending = false; spIds.forEach(function (id) { if (want[id] === sentSp[id]) delete want[id]; }); paint(); PB.emit('cart:change', view()); sync(); })
.catch(function (err) {
sending = false;
var msg = err && (err.description || err.message);
if (!err || err.status === undefined || err.status >= 500) msg = T('cart_offline');
say(msg || T('cart_error'));
spIds.forEach(function (id) { delete want[id]; });
req(URL_GET).then(function (c) { server = c; learn(c); }).catch(function () {}).then(function () { paint(); flush(); });
});
return;
}
var upd = {}, sent = {};
    ids.forEach(function (id) { upd[id.indexOf('k:') === 0 ? id.slice(2) : id] = want[id]; sent[id] = want[id]; });
    sending = true; again = false;
    req(URL_UPD, { updates: upd }).then(function (c) {
      server = c; learn(c); sending = false;
      Object.keys(sent).forEach(function (id) {
        var got = serverQty(id);
        if (want[id] === sent[id]) {                     /* kunden har ikke klikket igen imens */
          if (got < sent[id]) { say(got > 0 ? T('cart_stock', 'n', got) : T('sold_out')); var m = meta[id]; if (m) m.stock = got; }
          delete want[id];                               /* Shopifys tal er nu sandheden */
        }
      });
      paint(); PB.emit('cart:change', view());
      sync();
    }).catch(function (err) {
      sending = false;
      var msg = err && (err.description || err.message);
      if (!err || err.status === undefined || err.status >= 500) msg = T('cart_offline');
      say(msg || T('cart_error'));
      /* tilbage til Shopifys sandhed — ingen halve tilstande */
      req(URL_GET).then(function (c) { server = c; learn(c); }).catch(function () {}).then(function () { want = {}; paint(); flush(); });
    });
  }
  function reconcileLater() { clearTimeout(recT); recT = setTimeout(function () { if (!sending && !pending().length) refresh(); }, 1500); }
  function refresh() { return req(URL_GET).then(function (c) { if (sending || pending().length) return c; server = c; learn(c); want = {}; paint(); return c; }).catch(function () { return server; }); }
  function whenIdle() { return new Promise(function (res) { if (!sending && !pending().length) res(); else waiters.push(res); }); }
  function flush() { if (sending || pending().length) return; var a = waiters; waiters = []; a.forEach(function (f) { f(); }); }

  /* ---------------- tegning: linjer genbruges (samme billede, intet blink) ---------------- */
  var ICO_MINUS = '<svg class="pb-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 12h12"/></svg>';
  var ICO_PLUS = '<svg class="pb-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 12h12M12 6v12"/></svg>';
  function sized(src, wd) { try { var u = new URL(src, location.href); u.searchParams.set('width', wd); return u.toString(); } catch (e) { return src; } }
  function metasHTML(c, i) {
    var s = i.variant_title && !/default title/i.test(i.variant_title) ? '<span class="pb-line__meta">' + PB.esc(i.variant_title) + '</span>' : '';
if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.name) s += '<span class="pb-line__meta">' + PB.esc(i.selling_plan_allocation.selling_plan.name) + '</span>'; /* abonnement, fx "Fornyes hver måned" */
    Object.keys(i.properties || {}).forEach(function (k) { if (k.charAt(0) !== '_' && i.properties[k]) s += '<span class="pb-line__meta">' + PB.esc(k) + ': ' + PB.esc(i.properties[k]) + '</span>'; });
    (i.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && a.discount_application.title; if (t && a.amount > 0 && !discOurs(a)) s += '<span class="pb-line__disc">' + PB.esc(t) + ' (−' + PB.money(a.amount) + ')</span>'; });
    var m = meta[i.variant_id] || {};
    if (m.max > 0) s += '<span class="pb-line__limit">' + PB.esc(T('cart_limit', 'n', m.max)) + '</span>';
    else if (m.pool && m.pmax > 0) s += '<span class="pb-line__limit">' + PB.esc(T('cart_limit', 'n', m.pmax)) + '</span>';
    return s;
  }
  function wasLine(i) { return Math.max(((meta[i.variant_id] || {}).compare || 0) * i.quantity, i.original_line_price || 0); }
  function priceHTML(i) {
    var was = wasLine(i), m = meta[i.variant_id] || {};
    var h = (was > i.final_line_price ? '<s class="pb-line__was">' + PB.money(was) + '</s>' : '') + '<b>' + PB.money(i.final_line_price) + '</b>';
    /* "Kun X på lager" står under prisen (egen kolonne) — knapperne flytter sig aldrig */
    if (m.stock > 0 && i.quantity >= m.stock && !(m.max > 0 && m.max <= m.stock)) h += '<em class="pb-line__stock">' + PB.esc(T('cart_stock', 'n', m.stock)) + '</em>';
    return h;
  }
  function lineHTML(c, i) {
    var m = meta[i.variant_id] || {}, src = m.img || (i.image ? sized(i.image, 160) : '');
    var img = src ? '<img class="pb-line__img" src="' + PB.esc(src) + '" alt="" width="64" height="64">' : '<span class="pb-line__img"></span>';
    return '<li class="pb-line" data-key="' + PB.esc(i.key) + '" data-v="' + i.variant_id + '">' + img +
      '<div class="pb-line__info"><a class="pb-line__title" href="' + PB.esc(i.url) + '">' + PB.esc(dec(i.product_title || i.title)) + '</a>' +
      '<div class="pb-line__metas"></div>' +
      '<div class="pb-line__ctl">' + (isGift(i) ? '<div class="pb-qty pb-qty--fixed"><span aria-live="polite">' + i.quantity + '</span></div>' : '<div class="pb-qty"><button type="button" class="pb-qty__b" data-q="-1" aria-label="' + PB.esc(T('qty_minus')) + '">' + ICO_MINUS + '</button>' +
      '<span aria-live="polite">' + i.quantity + '</span><button type="button" class="pb-qty__b" data-q="1" aria-label="' + PB.esc(T('qty_plus')) + '">' + ICO_PLUS + '</button></div>') +
      '<button type="button" class="pb-line__rm" data-rm>' + PB.esc(T('cart_remove')) + '</button></div></div>' +
      '<span class="pb-line__price"></span><div class="pb-line__dealrow"></div></li>';
  }
  function frag(html) { var t = d.createElement('template'); t.innerHTML = html; return t.content.firstChild; }
  var decT = d.createElement('textarea');
  function dec(s) { if (!s || s.indexOf('&') < 0) return s || ''; decT.innerHTML = s; return decT.value; }   /* Shopify sender titler med &#39; o.l. */
  function setHTML(el, html) { if (el && el._h !== html) { el.innerHTML = html; el._h = html; } }
  function renderInto(box, c) {
    if (!box) return;
    if (!c.items.length) {
      setHTML(box, '<p class="pb-cart__empty">' + PB.esc(T('cart_empty')) + '</p><a class="pb-btn pb-btn--ghost pb-btn--block" href="' + PB.esc(PB.cfg.root || '/') + '" data-pb-cart-close>' + PB.esc(T('cart_continue')) + '</a>');
      return;
    }
    var ul = $('ul.pb-lines', box), discs = $('[data-pb-cart-discs]', box);
    if (!ul) { box.innerHTML = '<ul class="pb-lines' + (box === pageEl ? ' pb-lines--page' : '') + '"></ul><div data-pb-cart-discs></div>'; box._h = null; ul = $('ul.pb-lines', box); discs = $('[data-pb-cart-discs]', box); }
    if (!discs) { discs = d.createElement('div'); discs.setAttribute('data-pb-cart-discs', ''); box.appendChild(discs); }
    var byKey = {}; $$('li.pb-line', ul).forEach(function (li) { byKey[li.getAttribute('data-key')] = li; });
    var keys = {}; c.items.forEach(function (i) { keys[i.key] = 1; });
    var used = [], prev = null;
    c.items.forEach(function (i) {
      var li = byKey[i.key];
      if (!li) li = $$('li.pb-line', ul).filter(function (x) { return used.indexOf(x) < 0 && !keys[x.getAttribute('data-key')] && +x.getAttribute('data-v') === i.variant_id; })[0];
      if (!li) li = frag(lineHTML(c, i));
      li.setAttribute('data-key', i.key); li.setAttribute('data-v', i.variant_id); li.classList.remove('is-leaving');
      setHTML($('.pb-line__metas', li), metasHTML(c, i));
      var q = $('.pb-qty span', li); if (q && q.textContent !== String(i.quantity)) q.textContent = i.quantity;
      var plus = $('[data-q="1"]', li); if (plus) plus.disabled = capFor(c, i.variant_id, i.key).n <= i.quantity;
      setHTML($('.pb-line__price', li), priceHTML(i));
setHTML($('.pb-line__dealrow', li), dealHTML(c, i)); /* under tekst + pris: mere plads, samme højde */
      used.push(li);
      var ref = prev ? prev.nextSibling : ul.firstChild;
      if (li !== ref) ul.insertBefore(li, ref);
      prev = li;
    });
    $$('li.pb-line', ul).forEach(function (li) { if (used.indexOf(li) < 0) li.remove(); });
    setHTML(discs, (c.cart_level_discount_applications || []).filter(function (a) { return a.total_allocated_amount > 0; }).map(function (a) {
      return '<div class="pb-cart__disc"><span>' + PB.esc(a.title || T('cart_discount')) + '</span><span>−' + PB.money(a.total_allocated_amount) + '</span></div>';
    }).join(''));
  }
  function savings(c) {
    var s = 0; c.items.forEach(function (i) { s += Math.max(0, wasLine(i) - (i.final_line_price || 0)); });
    (c.cart_level_discount_applications || []).forEach(function (a) { s += a.total_allocated_amount || 0; });
    return s;
  }
  function paint() {
    var c = view();
if (enforceCaps(c)) c = view();   /* rettede antal vises med det samme */
    $$('[data-pb-cart-count]').forEach(function (el) { var v = String(c.item_count); if (el.textContent !== v) el.textContent = v; if (el.classList.contains('pb-count')) el.hidden = c.item_count === 0; });
    renderInto(body, c); renderInto(pageEl, c); fitDeals(root); fitDeals(pageEl); fitWatch();
    $$('[data-pb-cart-foot]').forEach(function (f) { f.hidden = !c.items.length; });
    $$('[data-pb-cart-total]').forEach(function (t) { var v = PB.money(c.total_price); if (t.textContent !== v) t.textContent = v; });
    var sv = savings(c);
    $$('[data-pb-cart-save]').forEach(function (s) { s.hidden = sv <= 0; var alts = sv > 0 ? [T('cart_savings', 'amount', PB.money(sv)), T('cart_savings_s', 'amount', PB.money(sv)), '−' + PB.money(sv)] : [''], j = JSON.stringify(alts); if (s.getAttribute('data-fit') !== j) { s.setAttribute('data-fit', j); s.textContent = alts[0]; } fitDeals(s.parentNode); }); /* i total-rækken: længste tekst der kan stå på én linje */
    var ul = upList(c), pick = fsPick(c, ul);
    renderFS(c, pick);
    renderUpsell(c, ul, pick);
    renderGW(c); renderMUP(c);
    PB.emit('cart:view', c);
  }

  /* ---------------- fri fragt-bar ---------------- */
  function fsBase() {
    var txt = PB.cfg.freeShipping || '', cc = PB.cfg.country, cur = PB.cfg.currency, hit = null;
    txt.split(/\n+/).forEach(function (line) {
      var p = line.trim().split(':'); if (p.length < 3) return;
      var cs = p[0].split(',').map(function (s) { return s.trim().toUpperCase(); });
      if (cs.indexOf(cc) > -1 && p[2].trim().toUpperCase() === cur) hit = Math.round(parseFloat(p[1].replace(',', '.')) * 100);
    });
    return hit;
  }
  /* medlemmer: den laveste fri fragt-grænse (Medlemskab → "Fri fragt for medlemmer fra", fx DK:500) — også når medlemsvaren ligger i kurven */
function fsRule(c) {
var hit = fsBase(), m = MB.fs || 0;
if (m > 0 && mbActive(c || view())) hit = hit ? Math.min(hit, m) : m;
return hit;
}
function renderFS(c, pick) {
    $$('[data-pb-fs]').forEach(function (el) {
      var thr = fsRule(c);
      if (!thr || !c.items.length) { el.hidden = true; return; }
      var bf = giftFree(c) || rsFree(c), left = bf ? 0 : thr - c.total_price, pct = bf ? 100 : Math.max(0, Math.min(100, c.total_price / thr * 100)), done = left <= 0;
      var txt = done ? T('fs_done') : T('fs_left', 'amount', PB.money(left));
      var row = $('.pb-fs__row span', el), bar = $('.pb-fs__bar', el);
      if (!row || !bar) { el.innerHTML = '<div class="pb-fs__row"><svg class="pb-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg><span></span></div><div class="pb-fs__bar"><i></i></div>'; row = $('.pb-fs__row span', el); bar = $('.pb-fs__bar', el); }
      var fill = $('i', bar), ghost = $('.pb-fs__ghost', bar), sw = $('.pb-fs__sw', el);
      if (!ghost) { ghost = d.createElement('b'); ghost.className = 'pb-fs__ghost'; bar.appendChild(ghost); }
      if (!sw) { sw = d.createElement('div'); sw.className = 'pb-fs__sw'; sw.innerHTML = '<div class="pb-fs__swin"></div>'; el.appendChild(sw); }
      if (row.textContent !== txt) row.textContent = txt;
      fill.style.width = pct.toFixed(1) + '%';
      /* fri fragt-forslag: det stribede stykke viser præcis hvor langt varen rækker (= helt i mål) */
      var show = !done && !!pick;
      if (show) shownPick = pick;
      ghost.style.left = pct.toFixed(1) + '%';
      ghost.style.width = show ? (100 - pct).toFixed(1) + '%' : '0%';
      if (show) {
        var inner = $('.pb-fs__swin', sw), cur = $('.pb-fs__sug', inner);
        if (!cur || cur.getAttribute('data-v') !== String(pick.id)) {
          inner.innerHTML = '<div class="pb-fs__sug" data-v="' + pick.id + '"' + (pick.lc ? ' style="--lc:' + PB.esc(pick.lc) + '"' : '') + '>' +
            (pick.image ? '<img src="' + PB.esc(pick.image) + '" alt="" width="40" height="40" decoding="async" fetchpriority="high">' : '') +
            '<div class="pb-fs__sugt"><b>' + PB.esc(pick.title) + '</b><span>' + PB.esc(T(pick.seen ? 'up_fs_seen' : 'up_fs_hint')) + '</span></div>' +
            '<button type="button" class="pb-fs__add" data-pb-up-add="' + pick.id + '">+ ' + PB.money(pick.price) + '</button></div>';
          fadeImgs(inner);
        }
      }
      el.classList.toggle('has-sug', show);
      el.classList.toggle('is-done', done); el.hidden = false;
    });
  }

  /* ---------------- giveaway: ét lille lilla linje i bunden — adskilt fra fri fragt (gul, øverst) ---------------- */
  var GIFT = '<svg class="pb-ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"><rect x="3.5" y="8.5" width="17" height="4" rx="1"/><path d="M5 12.5v8h14v-8M12 8.5v12M12 8.5c-1.5-3.6-6-4.2-6-1.5 0 1.5 2.5 1.5 6 1.5zm0 0c1.5-3.6 6-4.2 6-1.5 0 1.5-2.5 1.5-6 1.5z"/></svg>';
  function renderGW(c) {
    var g = PB.cfg.gw, today = new Date().toISOString().slice(0, 10);
    $$('[data-pb-gwline]').forEach(function (el) {
      if (!g || !g.min || !c.items.length || today < g.fra || today > g.til) { el.hidden = true; return; }
      var inn = c.total_price >= g.min;
      var nT = MB.lt > 1 && mbActive(c) ? MB.lt : 1; /* medlemmer (også når medlemskabet ligger i kurven): flere lodder pr. ordre */
var txt = nT > 1 ? (inn ? T('gw_in_n', 't', g.t) : T('gw_more_n', 't', g.t).replace('[a]', PB.money(g.min - c.total_price))).replace('[n]', nT) : (inn ? T('gw_in', 't', g.t) : T('gw_more', 't', g.t).replace('[a]', PB.money(g.min - c.total_price)));
      var html = GIFT + '<a href="' + PB.esc(g.url) + '">' + PB.esc(txt) + '</a>';
      if (el._h !== html) { el.innerHTML = html; el._h = html; }
      el.classList.toggle('is-in', inn); el.hidden = false;
    });
  }

  /* ---------------- medlemskab-upsell (ikke-medlemmer): én fast linje i bunden ved totalen ----------------
   Hvad kunden ville spare på DENNE ordre som medlem — samme regler som checkout (medlemspris først, mængderabat af den,
   én produktrabat pr. vare, pr. stk. rundet ned) + om ordren så får fri fragt. Til højre prisen pr. måned, eller
   "Betaler sig selv", når besparelsen er større. Den længste tekst, der kan stå på én linje, vælges. */
var CROWN = '<svg class="pb-ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"><path d="M3.5 8 8 12l4-6.5 4 6.5 4.5-4-1.8 10H5.3z"/><path d="M5.5 20.5h13"/></svg>';
function mupSave(c) {
var G = qdGroups(c), b2b = !!(PB.cfg.customer || {}).b2b, save = 0;
(c.items || []).forEach(function (i) {
var m = meta[i.variant_id] || {}, x = m.qk && !b2b ? G[m.qk] : null; /* som medlem: altid vores mængderabat + medlemspris */
var vol = x ? qdGroupPct(x) : 0, mem = mbPct(i, true);
var amt = unitOff(i.original_price, vol, mem) * i.quantity;
var now = (i.line_level_discount_allocations || []).reduce(function (s, a) { return Math.max(s, a.amount || 0); }, 0);
if (amt > now) save += amt - now;
});
return save;
}
function renderMUP(c) {
$$('[data-pb-mup]').forEach(function (el) {
if (!MB.show || MB.cust || MB.b2b || !c.items.length) { el.hidden = true; return; }
var joining = !!MB.pid && c.items.some(function (i) { return String(i.product_id) === String(MB.pid); });
var save = joining ? 0 : mupSave(c), fsM = MB.fs || 0, base = fsBase(), after = c.total_price - save;
var ship = !joining && fsM > 0 && after >= fsM && !(base && c.total_price >= base);
var price = MB.price > 0 ? T('mup_price').replace('[price]', PB.money(MB.price)) : '', cancel = T('mup_cancel');
var pays = !joining && MB.price > 0 && save >= MB.price;
var top, sub;
if (joining) { top = [T('mup_joining'), T('mup_joining_s')]; sub = [T('mup_joining_sub')]; }
else {
top = (save > 0 ? [T('mup_save'), T('mup_save_s'), T('mup_save_t')] : ship ? [T('mup_fs'), T('mup_fs_s')] : [fsM > 0 ? T('mup_info') : T('mup_info_nf'), T('mup_info_s')]).map(function (s) { return s.replace('[amount]', PB.money(save)); });
var lead = [save > 0 && ship ? T('mup_fs_plus') : '', pays ? T('mup_pays') : ''].filter(Boolean).join(' · ');
sub = [[lead, price, cancel], [lead, price], [lead || price]].map(function (p) { return p.filter(Boolean).join(' · '); }).filter(Boolean);
}
var html = CROWN + '<span class="pb-mup__txt"><b class="pb-mup__t" data-fit="' + PB.esc(JSON.stringify(top)) + '">' + PB.esc(top[0]) + '</b>' +
'<span class="pb-mup__s" data-fit="' + PB.esc(JSON.stringify(sub)) + '">' + PB.esc(sub[0] || '') + '</span></span>' +
(joining || !MB.variant ? '' : MB.enabled ? '<button type="button" class="pb-mup__btn" data-pb-mup-add>' + PB.esc(T('mup_join')) + '</button>' : '<span class="pb-mup__btn is-soon">' + PB.esc(T('mup_soon')) + '</span>'); /* checkout tager ikke imod endnu (ikke åbent, ikke test-kunde) */
if (el._h !== html) { el.innerHTML = html; el._h = html; }
el.classList.toggle('is-pays', !!pays); el.classList.toggle('is-joining', joining); el.hidden = false;
fitDeals(el);
});
}

/* ---------------- upsell ---------------- */
  var upMap = {}, shownPick = null;   /* shownPick = forslaget i fragtmåleren (kan komme fra puljen/"købt sammen") */
  function upList(c, noMap) {
    var inCart = {}, seen = {}, out = [];
    c.items.forEach(function (i) { inCart[i.product_id] = 1; });
    function push(x) { if (!x || !x.id || isRS(x) || seen[x.product_id] || inCart[x.product_id]) return; seen[x.product_id] = 1; out.push(x); }
    c.items.forEach(function (i) { (UP.prod[i.product_id] || []).forEach(push); });
    c.items.forEach(function (i) { (UP.pcols[i.product_id] || []).forEach(function (h) { (UP.cols[h] || []).forEach(push); }); });
    (UP.def || []).forEach(push);
    if (!noMap) { upMap = {}; out.forEach(function (x) { upMap[x.id] = x; }); }
    return out;
  }
  /* ---------------- fri fragt-forslaget: den vare kunden helst vil have ----------------
     Kun varer der dækker HELE beløbet. Blandt dem vælges den med højest "chance" ud fra:
       • hvilke spil der ligger i kurven (stærkest), kundens tidligere køb (indloggede)
       • hvad kunden har kigget på / søgt efter / hvor kunden kom fra (pb-signals, kun med samtykke)
       • sprog (engelsk/japansk/…) som i kurven, Shopifys "købt sammen"-forslag, dine egne valg
       • så lidt ekstra udgift som muligt (tæt på det manglende beløb)
     Varer kunden allerede har købt før, nedprioriteres (undtagen tilbehør som sleeves). */
  var POOL = null, REL = {}, lastPick = null, poolDirty = false;
  var rootUrl = (PB.cfg && PB.cfg.root) || '/';
  if (rootUrl.slice(-1) !== '/') rootUrl += '/';
  function loadPool() {
    if (POOL) return;
    try { var c0 = JSON.parse(sessionStorage.getItem('pbPool2') || 'null'); if (c0 && c0.t > Date.now() - 6e5) { POOL = c0.d; return; } } catch (e) {}
    POOL = { fill: [], bought: [], bg: [] };
    fetch(rootUrl + '?section_id=pb-upsell-pool', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
      var m = h.match(/<script[^>]*data-pb-pool[^>]*>([\s\S]*?)<\/script>/); if (!m) return;
      POOL = JSON.parse(m[1]);
      try { sessionStorage.setItem('pbPool2', JSON.stringify({ t: Date.now(), d: POOL })); } catch (e) {}
      later();
    }).catch(function () {});
  }
  function loadRel(c) { c.items.forEach(function (i) { loadRelId(i.product_id, (meta[i.variant_id] || {}).g); }); }
  function loadRelId(pid, game) {
      if (!pid || REL[pid]) return;
      REL[pid] = [];
      var m0 = { g: game || '' };
      fetch(rootUrl + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(function (j) {
          REL[pid] = (j.products || []).map(function (p) {
            if (p.type === RS || p.vendor === RS || (p.tags || []).indexOf('ripnship') > -1) return null;   /* rip n ship foreslås aldrig */
            var v = (p.variants || []).filter(function (x) { return x.available; })[0]; if (!v) return null;
            return { id: v.id, product_id: p.id, title: p.title, variant_title: null, price: v.price, compare: v.compare_at_price || 0,
                     image: p.featured_image ? sized(p.featured_image, 240) : null,
                     url: '/products/' + p.handle, g: m0.g || '', pt: p.type || '', rel: 1 };
          }).filter(Boolean);
          later();
        }).catch(function () {});
  }
  /* nye data mens kurven er åben → vent til den lukkes (forslaget skifter aldrig for øjnene af kunden) */
  function later() {
    if (isOpen()) poolDirty = true; else paint();
    var c = view(), p = fsPick(c, upList(c, true), true); if (p) preload(p.image);
    if (predItem) predict(predItem);   /* nye forslag kom ind → hent billedet til det NYE forslag også */
  }
  /* ---- billeder klar på forhånd ---- */
  var pre = {}, predItem = null;
  function preload(u) { if (!u || pre[u]) return; pre[u] = 1; var im = new Image(); im.decoding = 'async'; im.src = u; }
  function fadeImgs(box) {
    $$('img', box).forEach(function (im) {
      if (im.complete && im.naturalWidth) return;
      im.classList.add('is-wait');
      var done = function () { im.classList.remove('is-wait'); };
      im.addEventListener('load', done, { once: true }); im.addEventListener('error', done, { once: true });
    });
  }
  /* forudsig forslaget for varen kunden er ved at lægge i — og hent dens billede med det samme */
  function predict(it) {
    if (!it || !it.id) return;
    predItem = it;
    var c = view(), items = c.items.slice(), vid = +it.id;
    if (!items.some(function (i) { return i.variant_id === vid; })) items.unshift({ variant_id: vid, product_id: it.product_id, product_title: it.title, quantity: 1 });
    var c2 = { items: items, total_price: c.total_price + num(it.price) };
    var had = !!meta[vid]; if (!had) meta[vid] = { g: it.g || '', pt: it.pt || '' };
    var list = upList(c2, true), p = fsPick(c2, list, true);
    if (!had) delete meta[vid];
    if (p) preload(p.image);
    list.slice(0, 4).forEach(function (x) { preload(x.image); });
  }
  function isOpen() { return !!(root0() && root0().classList.contains('is-open')); }
  function root0() { return d.querySelector('[data-pb-cart]'); }

  function langOf(t) { t = String(t || ''); return /engelsk|english/i.test(t) ? 'en' : /japansk|japanese/i.test(t) ? 'jp' : /kinesisk|chinese/i.test(t) ? 'cn' : /koreansk|korean/i.test(t) ? 'kr' : ''; }
  function isAcc(x) { return /sleeve|toploader|case|card care|tilbeh|binder|deck ?box|playmat|kurt/i.test((x.pt || '') + ' ' + (x.title || '')); }
  function fsPick(c, list, dry) {
    var thr = fsRule(c); if (!thr || !c.items.length || hasRS(c)) return null;
    var left = thr - c.total_price; if (left <= 0) { if (!dry) lastPick = null; return null; }
    var inCart = {}; c.items.forEach(function (i) { inCart[i.product_id] = 1; });
    /* kandidater: egne valg + standardliste + fyld-op pr. spil + Shopifys "købt sammen" */
    var cands = [], seen = {};
    function add(x, tag) { if (!x || !x.id || inCart[x.product_id] || x.price < left) return; var k = x.product_id; if (seen[k]) { if (tag) seen[k][tag] = 1; return; } var y = Object.assign({}, x); if (tag) y[tag] = 1; seen[k] = y; cands.push(y); }
    list.forEach(function (x) { add(x, 'pick'); });
    (POOL && POOL.fill || []).forEach(function (x) { add(x); });
    c.items.forEach(function (i) { (REL[i.product_id] || []).forEach(function (x) { add(x, 'rel'); }); });
    if (!cands.length) { if (!dry) lastPick = null; return null; }
    /* samme forslag så længe kurven er åben og det stadig passer */
    if (!dry && lastPick && isOpen() && seen[lastPick.product_id]) return seen[lastPick.product_id];

    var S = (PB.signals && PB.signals.get()) || { v: [], c: [], s: [], ref: null }, t = Date.now();
    var gA = {}, lA = {};
    function addG(g, v) { if (g) gA[g] = (gA[g] || 0) + v; }
    function addL(l, v) { if (l) lA[l] = (lA[l] || 0) + v; }
    function fade(t0, days) { return Math.exp(-(t - t0) / (days * 864e5)); }
    c.items.forEach(function (i) { var m = meta[i.variant_id] || {}; addG(m.g, 3 * Math.min(i.quantity, 3)); addL(langOf(i.product_title), 2); });
    (S.v || []).forEach(function (x) { var f = fade(x.t, 3); addG(x.g, 1.5 * f); addL(langOf(x.ti), f); });
    (S.c || []).forEach(function (x) { addG(x.g, 0.8 * fade(x.t, 3)); });
    if (S.ref && S.ref.land && S.ref.land.g) addG(S.ref.land.g, 2);
    (POOL && POOL.bg || []).forEach(function (g) { addG(g, 0.4); });
    var gMax = 0, lMax = 0, k;
    for (k in gA) gMax = Math.max(gMax, gA[k]);
    for (k in lA) lMax = Math.max(lMax, lA[k]);
    var viewed = {}; (S.v || []).forEach(function (x) { viewed[x.id] = Math.max(viewed[x.id] || 0, fade(x.t, 7)); });
    var words = []; (S.s || []).forEach(function (x) { String(x.q).split(/[^a-z0-9æøåäöü]+/i).forEach(function (wd) { if (wd.length >= 3) words.push(wd); }); });
    var bought = {}; (POOL && POOL.bought || []).forEach(function (id) { bought[id] = 1; });

    var best = null;
    cands.forEach(function (x) {
      var sc = 0, ti = String(x.title || '').toLowerCase();
      if (gMax) sc += 4 * (gA[x.g] || 0) / gMax;
      if (lMax) sc += 1.5 * (lA[langOf(x.title)] || 0) / lMax;
      sc += 3 * (viewed[x.product_id] || 0);
      if (words.some(function (wd) { return ti.indexOf(wd) >= 0; })) sc += 1.5;
      if (x.rel) sc += 1.5;
      if (x.pick) sc += 1;
      if (bought[x.product_id] && !isAcc(x)) sc -= 2;
      sc -= 1.2 * Math.min((x.price - left) / Math.max(left, 5000), 3);
      if (!best || sc > best.sc || (sc === best.sc && x.price < best.x.price)) best = { sc: sc, x: x };
    });
    var pick = best.x;
    pick.seen = (viewed[pick.product_id] || 0) > 0.15;
    if (!dry) lastPick = pick;
    return pick;
  }

  function upHTML(x) {
    return '<div class="pb-up" data-v="' + x.id + '"' + (x.lc ? ' style="--lc:' + PB.esc(x.lc) + ';--lc-ink:' + PB.esc(x.ink || '#111') + '"' : '') + '>' +
      '<a class="pb-up__img" href="' + PB.esc(x.url) + '">' + (x.image ? '<img src="' + PB.esc(x.image) + '" alt="" width="120" height="120" decoding="async">' : '') + '</a>' +
      '<a class="pb-up__t" href="' + PB.esc(x.url) + '">' + PB.esc(x.title) + '</a>' +
      '<div class="pb-up__f"><span class="pb-up__p">' + PB.money(x.price) + '</span><button type="button" class="pb-up__add" data-pb-up-add="' + x.id + '" aria-label="' + PB.esc(T('up_add')) + '">+</button></div></div>';
  }
  function renderUpsell(c, list, pick) {
    var items = list.filter(function (x) { return !pick || x.id !== pick.id; }).slice(0, 6);
    $$('[data-pb-upsell]').forEach(function (box) {
      var on = c.items.length > 0 && items.length > 0 && !hasRS(c);   /* rip n ship-kurv: ingen forslag */
      box.classList.toggle('is-on', on);
      if (!on) return;                                   /* tom kurv: rækken røres ikke (ingen unødig bevægelse) */
      var track = $('[data-pb-up-track]', box);
      if (!track) { box.innerHTML = '<div class="pb-upsell__in"><p class="pb-upsell__t">' + PB.esc(T('up_title')) + '</p><div class="pb-upsell__row" data-pb-up-track></div></div>'; track = $('[data-pb-up-track]', box); dragRow(track); }
      var byId = {}; $$('.pb-up', track).forEach(function (el) { byId[el.getAttribute('data-v')] = el; });
      var keep = {}, prev = null;
      items.forEach(function (x) {
        var el = byId[x.id];
        if (!el || el.classList.contains('is-leaving')) { el = frag(upHTML(x)); fadeImgs(el); }
        keep[x.id] = 1;
        var ref = prev ? prev.nextElementSibling : track.firstElementChild;
        if (el !== ref) track.insertBefore(el, ref || null);
        prev = el;
      });
      Object.keys(byId).forEach(function (k) {
        var el = byId[k];
        if (keep[k] || el.classList.contains('is-leaving')) return;
        el.classList.add('is-leaving'); setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 420);   /* glider ud, rækken lukker hullet */
      });
    });
  }
  function dragRow(t) {
    var dr = null, mv = false;
    t.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; dr = { x: e.clientX, sl: t.scrollLeft }; mv = false; });
    t.addEventListener('pointermove', function (e) { if (!dr) return; var dx = e.clientX - dr.x; if (!mv) { if (Math.abs(dx) < 5) return; mv = true; t.classList.add('is-drag'); } t.scrollLeft = dr.sl - dx; });
    function end() { dr = null; if (mv) { t.classList.remove('is-drag'); setTimeout(function () { mv = false; }, 0); } }
    t.addEventListener('pointerup', end); t.addEventListener('pointerleave', end); t.addEventListener('pointercancel', end);
    t.addEventListener('click', function (e) { if (mv) { e.preventDefault(); e.stopPropagation(); } }, true);
    t.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------------- panel ---------------- */
  function open() {
    if (!root || PB.cfg.template === 'cart' || root.classList.contains('is-open')) return;
    lastFocus = d.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); PB.lock(true);
    var x = $('.pb-drawer__head [data-pb-cart-close]', root); if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); PB.lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    lastPick = null; if (poolDirty) { poolDirty = false; setTimeout(paint, 300); }
  }

  learn(server);
  PB.ready(function () {
    root = $('[data-pb-cart]'); pageEl = $('[data-pb-cartpage-body]');
    if (root) { panel = $('.pb-drawer__panel', root); body = $('[data-pb-cart-lines]', root) || $('[data-pb-cart-body]', root); }
    paint();
    /* aktive rabatkoder står ikke i sidens kurv-data → hentes stille lige efter load,
       så rabatten er klar før kunden når at klikke (også på første vare) */
    if (!server.discount_codes) PB.idle(refresh, 800);
    PB.idle(function () {
      upList(view(), true).slice(0, 8).forEach(function (x) { preload(x.image); });
      /* hent puljen + "købt sammen" i forvejen, så forslaget er klogt allerede ved første vare */
      loadPool(); loadRel(view());
      try { var cx = JSON.parse((d.getElementById('pb-ctx') || {}).textContent || '{}'); if (cx.t === 'p') loadRelId(cx.pid, cx.g); } catch (e) {}
    }, 1500);
    /* på kategori-/forsiden: hent "købt sammen" i det øjeblik kunden rører en "Læg i kurv"-knap */
    d.addEventListener('pointerdown', function (e) {
      var f = e.target.closest && e.target.closest('form[data-pb-add]'); if (!f) return;
      try { var it = JSON.parse(f.getAttribute('data-pb-item') || '{}'); loadRelId(it.product_id, it.g); predict(it); } catch (x) {}
    }, { passive: true });
    var hov = typeof WeakSet === 'function' ? new WeakSet() : null;
    d.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse' || !hov) return;
      var f = e.target.closest && e.target.closest('form[data-pb-add]'); if (!f || hov.has(f)) return;
      hov.add(f);
      try { var it = JSON.parse(f.getAttribute('data-pb-item') || '{}'); loadRelId(it.product_id, it.g); setTimeout(function () { predict(it); }, 250); } catch (x) {}
    }, { passive: true });

    /* Shopifys egen "lagt i kurv"-måling lytter både på formularens submit og på svaret fra /cart/update.js — uden denne linje
   talte hvert klik på "Læg i kurv" to gange (Google Ads/Meta/Analytics). preventDefault allerede i capture-fasen = Shopify springer
   formular-målingen over; svaret fra update.js tæller som før (ét event pr. lagt i kurv, også fra kurvens + og forslag). */
d.addEventListener('submit', function (e) { var f = e.target && e.target.closest && e.target.closest('form[data-pb-add]'); if (f) e.preventDefault(); }, true);
d.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('form[data-pb-add]');
      if (f) {
        e.preventDefault();
        if (f._pbT && Date.now() - f._pbT < 350) return;      /* dobbeltklik = ét klik */
        f._pbT = Date.now();
        var item; try { item = JSON.parse(f.getAttribute('data-pb-item')); } catch (x) { f.submit(); return; }
        var fd = new FormData(f), id = parseInt(fd.get('id'), 10);
        if (id && id !== item.id) item = Object.assign({}, item, f._pbVariant || {}, { id: id });
        var host = f.closest('.pb-card, [data-pb-product], .pb-sp__panel, .pb-av__item, li');
        var im = host && host.querySelector('img'); if (im && (im.currentSrc || im.src)) item = Object.assign({}, item, { image: im.currentSrc || im.src });
        if (add(item, fd.get('quantity') || 1) === false) return;   /* ikke lagt i kurven (fx rip n ship + almindelige varer) → ingen "lagt i kurv"-animation */
        var b = f.querySelector('button[type=submit]');
        if (b) { b.classList.remove('is-added'); void b.offsetWidth; b.classList.add('is-added'); setTimeout(function () { b.classList.remove('is-added'); }, 1300); }
        return;
      }
      var co = e.target.closest && e.target.closest('form[data-pb-checkout-form]');
      if (co && (sending || pending().length)) {
        e.preventDefault(); sync();
        whenIdle().then(function () { var hid = d.createElement('input'); hid.type = 'hidden'; hid.name = 'checkout'; hid.value = '1'; co.appendChild(hid); co.submit(); });
      }
    });
    d.addEventListener('click', function (e) {
      var o = e.target.closest('[data-pb-cart-open]');
      if (o && PB.cfg.template !== 'cart' && root) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-pb-cart-close]')) { if (root && root.classList.contains('is-open')) { e.preventDefault(); close(); } return; }
      var mj = e.target.closest('[data-pb-mup-add]');
if (mj) { e.preventDefault(); if (MB.variant && MB.plan) add({ id: MB.variant, product_id: MB.pid, title: MB.title, variant_title: null, price: MB.price, compare: 0, image: MB.img, url: MB.url, max: 1, sp: MB.plan, spn: MB.planName }, 1); return; }
var ua = e.target.closest('[data-pb-up-add]');
      if (ua) {
        e.preventDefault();
        var uid = ua.getAttribute('data-pb-up-add'), x = upMap[uid] || (shownPick && String(shownPick.id) === uid ? shownPick : null); if (!x) return;
        ua.classList.add('is-done'); if (ua.classList.contains('pb-up__add')) ua.textContent = '\u2713';
        add(x, 1);
        return;
      }
      var ln = e.target.closest('.pb-line[data-key]'); if (!ln) return;
      if (!(root && root.contains(ln)) && !(pageEl && pageEl.contains(ln))) return;
      var key = ln.getAttribute('data-key'), c = view(), cur = c.items.filter(function (i) { return i.key === key; })[0];
      if (!cur) return;
      var q = e.target.closest('[data-q]');
      if (q) { e.preventDefault(); if (!q.disabled) setQty(key, cur.quantity + parseInt(q.getAttribute('data-q'), 10)); return; }
      if (e.target.closest('[data-rm]')) { e.preventDefault(); ln.classList.add('is-leaving'); setTimeout(function () { setQty(key, 0); }, 120); }
    });
    d.addEventListener('keydown', function (e) {
      if (!root || !root.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', panel).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    /* mobil: kurven er et flydende kort — træk det NED for at lukke (følger fingeren).
       Tablet/computer: swipe mod højre lukker sidepanelet. */
    if (panel) {
      var mob = function () { return w.matchMedia('(max-width:749px)').matches; };
      var sx = null, sy = null, dy = 0, t0 = 0, dragging = false, fromHead = false;
      panel.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; dy = 0; t0 = Date.now(); dragging = false;
        fromHead = !!e.target.closest('.pb-drawer__head');
      }, { passive: true });
      panel.addEventListener('touchmove', function (e) {
        if (sy === null || !mob()) return;
        var ddy = e.touches[0].clientY - sy, ddx = e.touches[0].clientX - sx;
        if (!dragging) {
          if (ddy < 8 || Math.abs(ddx) > ddy) return;                 /* kun træk nedad */
          var sc = (root && $('[data-pb-cart-body]', root)) || body;
          if (!fromHead && sc && sc.scrollTop > 0) return;             /* listen scroller op først */
          dragging = true; panel.classList.add('is-drag');
        }
        dy = Math.max(0, ddy); e.preventDefault();
        panel.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: false });
      panel.addEventListener('touchend', function (e) {
        if (sy === null) return;
        if (mob()) {
          if (dragging) {
            var v = dy / Math.max(1, Date.now() - t0);
            panel.classList.remove('is-drag'); panel.style.transform = '';
            if (dy > 110 || v > 0.55) close();
          }
        } else {
          var dx = e.changedTouches[0].clientX - sx, ady = Math.abs(e.changedTouches[0].clientY - sy);
          if (dx > 60 && ady < 50) close();
        }
        sx = sy = null; dragging = false;
      }, { passive: true });
    }
    d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'visible') refresh(); });
    w.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  });
})();
